import 'jquery';
import AOS from 'aos';
AOS.init();
import Collapse from 'bootstrap/js/dist/collapse';
import Modal from 'bootstrap/js/dist/modal';

window.$ = window.jQuery = jQuery;

require('./config');
require('./components/lazy-loader');
require('./components/accordion');
require('./components/navbar');
require('./components/popups');
require('./components/projects-slider');
require('./components/combine-slider');
require('./components/testimonial-slider');
require('./components/insulation-slider');
require('./components/custom-form');
